import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService, UserService } from '@app/core';

@Component({
  selector: 'app-website',
  templateUrl: './website.component.html',
  styleUrls: ['./website.component.css']
})
export class WebsiteComponent implements OnInit {
  currentUser: any;
  apellidos: string;
  nombres: string;
  email: string;

  username: string;
  isLoggedIn: boolean;
  userId: any;
  isSubcripcion: boolean;
  isdespleagado = false;

  constructor(
    private modalService: NgbModal,
    public router: Router,
    private authService: AuthenticationService,
    private modalservice: NgbModal,
    private userService: UserService
  ) {}

  ngOnInit() {
    // console.log(this.authService.credentials.user);
    if (this.authService.isAuthenticated()) {
      this.currentUser = this.authService.credentials.user;
      this.username = this.currentUser.username;
      this.userId = this.currentUser.id;
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
    }

    this.userService.userIsSuscripsion(this.userId).subscribe((res: any) => {
      this.isSubcripcion = res.success;
      // console.log(res);
    });
  }

  eliminarCache() {
    this.authService.logout();
    // RouterModule.forRoot(routes, {onSameUrlNavigation: ‘reload’}
    // this.router.onSameUrlNavigation = 'reload';
    // this.router.navigate(['/website'], {
    //   queryParams: {refresh: new Date().getTime()}
    // });
    // this.router.navigateByUrl('/website', { skipLocationChange: true }).then(() => {
    //   this.router.navigate(['/website']);
    // });
    //
    // this.router.events.subscribe((evt) => {
    //   if (evt instanceof NavigationEnd) {
    //     this.router.navigated = false;
    //     window.scrollTo(0, 0);
    //   }
    // });
    // this.router.events
    // this.router.navigate(['/'], { replaceUrl: true });
    this.router.navigate(['/website']);
    this.isLoggedIn = false;
  }

  // suscripcion() {
  //   this.isdespleagado = false;
  //   const modal = this.modalservice.open(SuscripcionComponent, {});
  //   modal.componentInstance.title = '';
  // }

  cambiar(b: boolean) {
    this.isdespleagado = b;
  }
}
